var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"tag-active-filter mr-3 mb-4",on:{"click":_vm.onClickButton}},[_c('span',{staticClass:"content-text-tag"},[_vm._v(_vm._s(_vm.friendlyName))]),_vm._v(" "),(_vm.clickable)?_c('i',{staticClass:"material-icons ml-2"},[_vm._v("close")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-659ce61e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TagActiveFilter.vue
// module id = null
// module chunks = 